import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Image } from 'src/components/Image/Image';
import { setIsFilter, getIsFilter } from 'src/lib/redux/modules/search';
import TrackingManager from 'src/lib/managers/TrackingManager';
import { setSidebar } from 'src/lib/redux/modules/sidebar';

const FilterButton = props => {
	const { clickable = true } = props;
	const dispatch = useDispatch();
	const isFilter = useSelector(state => getIsFilter(state.search));

	const imgFilterStyles = {
		width: '25px',
		marginRight: '5px',
		position: 'relative',
		top: '-1px',
	};
	if (clickable) {
		(imgFilterStyles.marginRight = '15px'), (imgFilterStyles.cursor = 'pointer');
	}
	const onClickFilterIcon = () => {
		if (!isFilter) {
			TrackingManager.trackEvent('Open Filter Bar');
		}
		//  else {
		// 	TrackingManager.trackEvent('Close Filter Bar');
		// }
		if (!clickable) {
			return;
		}
		dispatch(setSidebar(true));
		dispatch(setIsFilter());
	};
	return (
		<Image
			url={'/fresh/images/filter-icon.svg'}
			onClick={onClickFilterIcon}
			customStyles={imgFilterStyles}
			lazyLoad={false}
		/>
	);
};

export default FilterButton;
